// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9JtLU","container__label":"styles_container__label__ZVssQ","skeleton-animation":"styles_skeleton-animation__oh9ck"};